import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc33bbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputform" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("登録")
const _hoisted_4 = { class: "balancetable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "input-form",
      ref: "form",
      model: _ctx.slip,
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "日付"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.slip.tgt_date_obj,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slip.tgt_date_obj) = $event)),
              type: "date",
              placeholder: "Pick a day"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "種類"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.slip.kind_cd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.slip.kind_cd) = $event)),
              placeholder: "Select item kind"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.KIND_MST, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.kind_cd,
                    label: item.kind_nm,
                    value: item.kind_cd
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "支払方法"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.slip.method_cd,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slip.method_cd) = $event)),
              placeholder: "Select payment method"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAY_METHOD_MST, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.method_cd,
                    label: item.method_nm,
                    value: item.method_cd
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "金額"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.slip.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.slip.value) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "メモ"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.slip.memo,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.slip.memo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "input-field",
          label: "id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.slip.uuid,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.slip.uuid) = $event)),
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.submiting,
        onClick: _ctx.onsubmit
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.balancelist,
        style: {"display":"block","width":"240px","margin":"auto"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "method_nm",
            label: "種類",
            width: "120",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "value_fmt",
            label: "金額",
            width: "120",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])), [
      [_directive_loading, _ctx.balanceloading]
    ])
  ]))
}